const {
  REACT_APP_API_DOMAIN,
} = process.env;

const protocol = 'https:';
const API_DOMAIN = `${protocol}//${REACT_APP_API_DOMAIN}`;

export { API_DOMAIN};

export const LOGIN_URL = 'api/auth/login';
export const GET_MFA_URL = 'api/auth/mfa-code';
export const CHECK_MFA_URL = 'api/auth/verify-mfa-code';
export const REFRESH_TOKEN_URL = 'api/auth/refresh';
export const LOGIN_BY_PHONE = 'api/login/by_phone';
export const SEND_CODE = 'api/login/send_code';
export const REGISTER_URL = 'api/_p/user/register';
export const ME_URL = 'api/me';
export const REQUEST_PASSWORD_URL = 'api/auth/forgot-password';
export const POST_PAYMENT_COPMLETE = (paymentId: string): string => `api/payments/${paymentId}/complete`
export const POST_PAYMENT_CANCEL = (paymentId: string): string => `api/payments/${paymentId}/cancel`

export const GET_PAYMENTS_URL = 'api/payments'
export const GET_TRANSACTION_URL = 'api/transactions'
export const getRecoveryPasswordUrl = (email: string): string =>
  `/api/_p/reset_password/send_code?email=${email}`;
export const NEW_PASSWORD_URL = '/api/_p/change_password_from_link';

export const GET_USER_LIST = '/api/user/list'
export const CREATE_USER_URL = '/api/user/list';
export const getUserUrl = (userId: string): string => `/api/user/${userId}`;
export const SEND_INVITE_URL = '/api/user_activate/send';
export const delUserUrl = (id: number): string => `/api/user/${id}`;
export const editUserUrl = (userId: string): string => `/api/user/${userId}`;
export const linkrUrl = (): string => `api/auth/code/create`;
export const uploadUserAvatarUrl = (id: string): string => `/api/user/${id}/upload_photos`;
export const GET_TRANSACTIONS_URL = '/api/exchange/orders';
// sendRecive urls
export const TRANSACTION_FEE_URL = '/api/wallet/transaction_fee';
export const GET_WALLET_TRANSACTION_URL = '/api/transfers';
export const SEND_URL = '/wallet/send';
export const RECEIVE_URL = '/wallet/receive';
export const DECLINE_URL = '/api/transfers';
export const getWalledByUserId = (userId: string): string => `/api/wallet/${userId}`;
export const getWalledByTransactionId = (transactionId: string): string => `/api/wallet/transaction/${transactionId}`;
export const GET_NETWORK_FEE_URL = '/api/wallet/network_fee';
export const GET_WALLED_ADDRESS_URL = '/api/wallet/address';